<template>
  <div
    id="runMultipleModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Run multiple steps
          </h4>
        </div>
        <div class="modal-body">
          <p>
            How many years do you want to simulate?
          </p>
          <p>
            <input
              v-model="numberOfRuns"
              type="number"
            >
          </p>
          <p>
            <small>Simulation times are around 2 to 3 seconds per year.</small>
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-link"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="submitButtonClicked"
          >
            Run {{ numberOfRuns }} years
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import "bootstrap";

export default {
  data: function() {
    return {
      numberOfRuns: 2
    };
  },
  created() {
    this.$root.$data.eventHub.$on("show-runmultiple-modal", this.displayModal);
  },
  methods: {
    displayModal() {
      $("#runMultipleModal").modal("show");
    },
    submitButtonClicked() {
      $("#runMultipleModal").modal("hide");
      this.$root.$data.eventHub.$emit(
        "show-runmultiple-trigger",
        this.numberOfRuns
      );
    }
  }
};
</script>

<style lang="scss">
#runMultipleModal {
  .modal-body {
    text-align: center;
    padding-bottom: 20px;
  }
}
</style>
